<template>
    <div class="qksm">
        <p><b>（八）省拨资金预算安排情况（详见附表十）</b></p>
        <p>
            2022年{{$store.state.divData.divname}}纳入部门预算的省拨资金{{isMoney(T10.总计)}}万元。
        </p>
        <p>纳入部门预算的省拨资金项目：</p>
        <template v-for="(item, idx) in T10.分类">
            <p>
                {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元
            </p>
            <p class="indent">
                <div class="nogap">
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T10basis'+item.name" v-model:value="qksm['T10basis'+item.name]"></reason>
                    <reason type="textarea" rows="3" classname="qksm widest" :name="'T10content'+item.name" v-model:value="qksm['T10content' + item.name]"></reason>
                </div>
            </p>
        </template>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        data() {
            var qksm = this.$store.state.divData.qksm;
            for (let item of this.T10.分类) {
                qksm['T10basis' + item.name] = this.pickOneOf(qksm['T10basis' + item.name], item.basis)
                qksm['T10content' + item.name] = this.pickOneOf(qksm['T10content' + item.name], item.content)
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        props: {
            T10: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };

</script>